import ReactDOMServer from "react-dom/server";
import FormFooter from "../form-footer/FormFooter";
import LogoHeader from "../../../../../components/common/LogoHeader";

export function PrintPayrollForm(
  name,
  position,
  startDate,
  endDate,
  additionalSelectValue,
  payrollCode
) {
  const tableElement = document.querySelector("#payroll-table");

  const clonedTable = tableElement.cloneNode(true);
  const rows = Array.from(clonedTable.querySelectorAll("tr"));
  const colCount = rows[0]?.children.length || 0;

  console.log("ROWS", rows);

  console.log("colCount", colCount);

  for (let col = colCount - 1; col >= 0; col--) {
    let isEmptyColumn = true;

    // Loop through rows (skip the first row if it's the header row)
    for (let rowIndex = 2; rowIndex < rows.length; rowIndex++) {
      // start from index 1 to skip header
      const row = rows[rowIndex];
      const cell = row.children[col];
      if (!cell) continue;

      console.log("CELL", cell);

      const input = cell.querySelector("input");
      let value = input ? input.value : cell.textContent;

      console.log("VALUEEE", value);
      value = value?.trim().replace(/\s+/g, "") || "";

      // If a value exists and it's not one of the ignored values
      if (value && value !== "-" && value !== "–" && value !== "—") {
        isEmptyColumn = false;
        break;
      }
    }

    console.log("isEmptyColumn", isEmptyColumn);
    if (isEmptyColumn) {
      // If the column is empty, remove the column in each row
      for (let row of rows) {
        if (row.children[col]) {
          row.removeChild(row.children[col]);
        }
      }
    }
  }

  console.log("CLONE TABLE", clonedTable);

  const printContentHTML = clonedTable.outerHTML;

  console.log("TABLE ELEMENT", tableElement);

  if (!tableElement) {
    console.error("Table element not found for printing");
    return;
  }

  // Create an iframe for printing
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;

  // Capture the table's HTML directly from the DOM
  // const printContentHTML = tableElement.outerHTML;

  console.log("printContentHTML", printContentHTML);

  const formHeaderHTML = ReactDOMServer.renderToString(
    <div className="d-flex justify-content-center flex-column align-items-center flex-md-row p-2">
      <LogoHeader
        logoSrc={"/BIR.png"}
        altText="Print Logo"
        mainLabel="Republic Of the Philippines"
        subLabel="BUREAU OF IMMIGRATION"
        description="Patriotism * Integrity * Professionalism"
      />
      <img
        src={"/Bagong-Pilipinas-Logo.png"}
        className="img-fluid"
        style={{ maxWidth: "130px", maxHeight: "110px" }}
      />
    </div>
  );
  const formFooterHTML = ReactDOMServer.renderToString(
    <FormFooter name={name} position={position} />
  );

  const styles = Array.from(
    document.querySelectorAll("link[rel='stylesheet'], style")
  )
    .map((styleElement) => styleElement.outerHTML)
    .join("\n");

  // Inject everything into the iframe document
  iframeDoc.open();
  iframeDoc.write(`  
      <html>
        <head>
          <title>Print Payroll</title>
          <style>
          
  @page {
    size: landscape;
    margin: 15mm;
  }

  body {
    font-family: Arial, sans-serif;
    margin: 0;
  }

  .print-header {
    text-align: center;
    margin-bottom: 10px;
  }

  .print-body {
    margin: 0 10mm;
    padding: 10px;
    border: 2px solid red;
    /* Remove page-break-inside here */
  }

  .print-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 10px 20px;
    background: white;
    box-sizing: border-box;
    border-top: 1px solid #ccc;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    page-break-inside: auto;  /* Allow page breaks inside table */
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
    font-weight: bold;
  }

  @media print {
    .print-footer {
      position: fixed;
      bottom: 0;
    }

    th, td {
      font-size: 12px;
    }
  }

  </style>

          ${styles}
        </head>
      <body>
    <div class="print-header">
      ${formHeaderHTML}
      <p style="margin: 0;"><b>${additionalSelectValue}</b></p>
      <p style="margin: 0;"><b>${payrollCode}</b></p>
      <p style="margin: 0;">${startDate} - ${endDate}</p>
    </div>

    <div class="print-body">
    ${printContentHTML}
    </div>

    <div class="print-footer">
      ${formFooterHTML}
    </div>
  </body>


      </html>
    `);
  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
  }, 200);
  iframeDoc.close();

  // <div class="print-body">
  //   ${printContentHTML}
  // </div>

  // <div class="print-content">${printContentHTML}</div>

  //download pdf file
  // const { jsPDF } = window.jspdf;
  // const doc = new jsPDF({
  //   orientation: "landscape",
  //   unit: "px",
  //   format: "a4",
  // });

  // const htmlContent = `
  // <div style="text-align: center; width: 100%; font-family: Arial, sans-serif;;">
  //   <p">${additionalSelectValue}</p>
  //   ${formHeaderHTML}
  //   <p">${startDate} - ${endDate}</p>
  //   <div>${printContentHTML}</div>
  //   ${formFooterHTML}
  // </div>
  // `;

  // doc.html(htmlContent, {
  //   callback: function (doc) {
  //     doc.save("PayrollForm.pdf");

  //     setTimeout(() => {
  //       iframe.contentWindow.focus();
  //       iframe.contentWindow.print();
  //       document.body.removeChild(iframe);
  //     }, 200);
  //   },
  //   x: 0,
  //   y: 0,
  //   html2canvas: {
  //     scale: 0.5,
  //     logging: false,
  //     useCORS: true,
  //   },
  //   windowWidth: 1080,
  //   width: 1100,
  // });
}
